module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "swiper-fullscreen"
  }, [_c('swiper', {
    ref: "websiteSwiper",
    attrs: {
      "is-pagination": false,
      "height": '100%',
      "loop": false,
      "autoplay": 5000
    }
  }, [_c('swiper-item', {
    staticClass: "swiper-item"
  }, [_c('div', {
    staticClass: "cover-wrapper",
    staticStyle: {
      "height": "100%",
      "background-image": "url('/static/img/website-1.jpg')"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/website-1.jpg"
    }
  })])]), _vm._v(" "), _c('swiper-item', {
    staticClass: "swiper-item"
  }, [_c('div', {
    staticClass: "cover-wrapper",
    staticStyle: {
      "height": "100%",
      "background-image": "url('/static/img/website-2.png')"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/website-2.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "page-caption"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("登录手机官网三种方法")]), _vm._v(" "), _c('div', {
    staticClass: "point"
  })]), _vm._v(" "), _c('div', {
    staticClass: "anim-wrapper"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('img', {
    staticClass: "methods-img",
    attrs: {
      "src": "/static/img/website-3.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "methods-wrap"
  }, [_c('p', {
    staticClass: "methods"
  }, [_vm._v("方法一")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "iconfont"
  }, [_vm._v("")]), _vm._v(" 输入91weijia.com官网")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('img', {
    staticClass: "methods-img",
    attrs: {
      "src": "/static/img/website-4.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "methods-wrap"
  }, [_c('p', {
    staticClass: "methods"
  }, [_vm._v("方法二")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "iconfont"
  }, [_vm._v("")]), _vm._v(" 扫一扫进入手机官网")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('img', {
    staticClass: "methods-img",
    attrs: {
      "src": "/static/img/website-5.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "methods-wrap"
  }, [_c('p', {
    staticClass: "methods"
  }, [_vm._v("方法三")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "iconfont"
  }, [_vm._v("")]), _vm._v(" 微信公众号访问")])])])])])])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-5ccbef6e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/website.vue
// module id = 607
// module chunks = 1